import { useContext } from 'react';
import { FirstLoginTooltipsContext, IFirstLoginTooltipsContext } from 'context';

export function useFirstLoginTooltips(): IFirstLoginTooltipsContext {
  return useContext(FirstLoginTooltipsContext)!;
}
